import * as R from "ramda";
import { NboCase } from "../../features/nextBestOffer/NextBestOfferUtils";
import { getValue, getVolatileStorage, IStorage, Keys, setValue } from "./common";

const storage: IStorage = isSessionStorageAvailable() ? sessionStorage : getVolatileStorage("session");

interface FcDataPermissions {
    "LI-OPT"?: boolean;
    "LI-OM"?: boolean;
    "LI-NBA"?: boolean;
}

interface FcData {
    umid: string;
    permissions?: FcDataPermissions;
}

export const isAnalysisAllowed = (): boolean | undefined => {
    const valueStr = storage.getItem(Keys.FcData);
    if (R.isNil(valueStr)) {
        return undefined;
    }

    const obj = JSON.parse(valueStr) as FcData;
    const permissions = obj?.permissions;
    if (R.isNil(permissions)) {
        return undefined;
    }

    return permissions["LI-OPT"] ?? false;
}

export const getNboTeaseCase = (): NboCase | null => {
    const value = getValue(storage, Keys.NboTeaserCase);
    switch (value) {
        case NboCase.None:
        case NboCase.NonCustomer:
        case NboCase.GigabitCableCustomer:
        case NboCase.BelowGigabitCableCustomer:
            return value;
        default:
            return null;
    }
}

export const setNboTeaseCase = (nboCase: NboCase) => setValue(storage, Keys.NboTeaserCase, nboCase);

function isSessionStorageAvailable(): boolean {
    try {
        const storage = window["sessionStorage"];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return false;
    }
}

export const setupInterceptors = (callback: () => void) => {
    const old_setItem = storage.setItem;
    storage.setItem = function () {
        old_setItem.apply(this, [arguments[0], arguments[1]]);
        callback();
    }
}